<template>
  <div class="row container-stats">
    <div class="col-4 stats">
      <b-card class="earnings-card">
        <div class="row">
          <div class="col">
            <b-card-title class="mb-1">
              Tiempo máximo
            </b-card-title>
            <h5 class="mb-1">
              {{ resume.maxMinutosTranscurridosEjecucion | timeApprovals }}
            </h5>
          </div>
          <div class="col-auto text-center">
            <b-avatar
              size="48"
              variant="light-danger"
            >
              <feather-icon
                size="34"
                icon="AlertCircleIcon"
              />
            </b-avatar>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-4 stats">
      <b-card class="earnings-card">
        <div class="row">
          <div class="col">
            <b-card-title class="mb-1">
              Tiempo Mínimo
            </b-card-title>
            <h5 class="mb-1">
              {{ resume.minMinutosTranscurridosEjecucion | timeApprovals }}
            </h5>
          </div>
          <div class="col-auto text-center">
            <b-avatar
              size="48"
              variant="light-success"
            >
              <feather-icon
                size="34"
                icon="AwardIcon"
              />
            </b-avatar>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-4 stats">
      <b-card class="earnings-card">
        <div class="row">
          <div class="col">
            <b-card-title class="mb-1">
              Tiempo promedio
            </b-card-title>
            <h5 class="mb-1">
              {{ resume.avgMinutosTranscurridosEjecucion | timeApprovals }}
            </h5>
          </div>
          <div class="col-auto text-center">
            <b-avatar
              size="48"
              variant="light-info"
            >
              <feather-icon
                size="34"
                icon="ClockIcon"
              />
            </b-avatar>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    resume: { type: Object }
  }
};

</script>
